import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=025724aa&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025724aa",
  null
  
)

export default component.exports